module.exports = __webpack_public_path__ + "img/vida-verd-05.1ffa6bec.jpg";